import { BASE_URL } from "./SystemConstants";
export const SEND_COOPOWNER_NOTICE = BASE_URL + 'email/coopownernotice';
export const SEND_WAITINGLIST_NOTICE = BASE_URL + 'email/waitinglistnotice';
export const SEND_WAITINGLIST_PAYMENT_NOTICE = BASE_URL + 'email/waitinglistpaymentnotice';
export const SEND_WAITINGLIST_PAYMENT_LATE_NOTICE = BASE_URL + 'email/waitinglistpaymentlatenotice';

